import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';

interface PaginationProps {
    perPage: number;
    totalRecords: number;
    onPageChange: (page: any) => void;
    currentPage: number;
}

const Pagination: React.FC<PaginationProps> = ({ perPage, totalRecords, onPageChange , currentPage}) => {

    const [showing, setShowing] = React.useState<string>('');
    useEffect(() => {
        let pageCount = Math.ceil(totalRecords / perPage);
        if(pageCount == 1){
            setShowing(totalRecords.toString());
        }

        if (currentPage == pageCount) {
            setShowing(`${(currentPage - 1) * perPage + 1} - ${totalRecords}`);
        }
        else {
            setShowing(`${(currentPage - 1) * perPage + 1} - ${currentPage * perPage}`);
        }

        if(currentPage > 1 && Math.ceil(totalRecords / perPage) < currentPage){
            onPageChange(currentPage - 1);
        }
            


    }, [totalRecords, perPage, currentPage]);






    return (
        <div className='flex items-center gap-3'>
            <div className='italic text-[0.8rem] text-[#656565]'>
                {totalRecords > 0 && `Showing ${showing} out of ${totalRecords} records`}  
                
            </div>
            {Math.ceil(totalRecords / perPage) > 1 &&
                <ReactPaginate
                    initialPage={currentPage-1}
                    className='pagination'
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={(data:any)=>{
                        onPageChange(data.selected + 1);
                    }}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(totalRecords / perPage)}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                />
            }
        </div>

    );
};

export default Pagination;